import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    notificationModalOpen: false,
    passwordFormatModalOpen: false,
    cardLimitModalOpen: false,
    logoutModalOpen: false,
    dropDownCard: false,
    masterDropdownCard: false,
    publish: false,
    fieldId: [],
    dependentField: [],
    formName: "",
    userProfile: localStorage.getItem("currentUser") ? JSON.parse(localStorage.getItem("currentUser"))?.userProfile : ""
}

const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        setNotificationModalOpen: (state, action) => {
            state.notificationModalOpen = action.payload
            state.logoutModalOpen = false
        },
        setPublish: (state, action) => {
            state.publish = action.payload
        },
        setuserProfile: (state, action) => {
            state.userProfile = action.payload
        },
        setFieldId: (state, action) => {
            state.fieldId = action.payload
        },
        setDependentField: (state, action) => {
            state.fieldId = action.payload
        },
        setFormName: (state, action) => {
            state.formName = action.payload
        },

        setPasswordFormatModalOpen: (state, action) => {
            state.passwordFormatModalOpen = action.payload
        },
        setCardLimitModalOpen: (state, action) => {
            state.cardLimitModalOpen = action.payload
        },
        setLogoutModalOpen: (state, action) => {
            state.logoutModalOpen = action.payload
            state.notificationModalOpen = false
        },
        setDropDownCard: (state, action) => {
            state.dropDownCard = action.payload
        },
        setMasterDropdownCard: (state, action) => {
            state.masterDropdownCard = action.payload
        }
    },
})

export default globalSlice.reducer
export const {
    setNotificationModalOpen,
    setPasswordFormatModalOpen,
    setCardLimitModalOpen,
    setLogoutModalOpen,
    setDropDownCard,
    setDuplicateId,
    setPublish,
    setFieldId,
    setFormName,
    setMasterDropdownCard,
    setuserProfile
} = globalSlice.actions